import Cookies from "js-cookie";

const TokenKey = "hp-rising";//usercache_prefix_session hp-rising

export function getToken() {
  console.log("获取token", Cookies.get(TokenKey));
  return Cookies.get(TokenKey);
  // return sessionStorage.getItem('sep_admin_session')
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
  // return sessionStorage.setItem('sep_admin_session',token)
}

export function removeToken() {
  // return sessionStorage.removeItem('sep_admin_session')
  return Cookies.remove(TokenKey);
}

const RedirectPathKey = 'redirectPath'

// 保存登录后的跳转路径
export function setRedirectPath(path) {
  sessionStorage.setItem(RedirectPathKey, path)
}

// 获取登录后的跳转路径
export function getRedirectPath() {
  return sessionStorage.getItem(RedirectPathKey)
}

// 清除保存的跳转路径
export function removeRedirectPath() {
  sessionStorage.removeItem(RedirectPathKey)
}
